import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Buildings, Calendar } from "@phosphor-icons/react";

export default function Publishers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/publishers"); setItems(data); } catch { /* */ }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="pt-20 max-w-6xl mx-auto px-5 lg:px-8 pb-24" data-testid="publishers-page">
      <div className="mb-10">
        <div className="font-mono-accent text-xs text-[#E63946] mb-2">◢ INDÚSTRIA</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">Editoras</h1>
        <p className="text-zinc-400 mt-2">Editoras de mangá com presença em Portugal.</p>
      </div>

      {loading ? (
        <div className="text-center font-mono-accent text-xs text-zinc-500 py-10">A CARREGAR...</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-white/10 rounded-2xl py-20 text-center">
          <Buildings size={42} weight="duotone" className="text-[#E63946] mx-auto mb-3" />
          <div className="font-display font-bold text-xl">Sem editoras adicionadas</div>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map(p => <PublisherCard key={p.publisher_id} pub={p} />)}
        </div>
      )}
    </div>
  );
}

export function PublisherCard({ pub }) {
  return (
    <Link
      to={`/editoras/${pub.publisher_id}`}
      className="card-hover bg-[#121217] border border-white/5 rounded-2xl p-5 flex items-center gap-4 block group"
      data-testid={`publisher-${pub.publisher_id}`}
    >
      {pub.image_url ? (
        <img src={pub.image_url} alt={pub.name} className="w-16 h-16 object-contain bg-white/5 rounded-lg p-2 flex-shrink-0" />
      ) : (
        <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-[#E63946]/20 to-[#7209B7]/20 grid place-items-center flex-shrink-0">
          <Buildings size={28} weight="duotone" className="text-[#E63946]" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold text-lg truncate group-hover:text-[#E63946] transition-colors">{pub.name}</div>
        <div className="font-mono-accent text-[10px] text-zinc-500 mt-1 flex items-center gap-1">
          {pub.founded_year && (
            <><Calendar size={10} weight="bold" /> {pub.founded_year}</>
          )}
        </div>
        {pub.description && <div className="text-xs text-zinc-400 line-clamp-2 mt-1">{pub.description}</div>}
      </div>
    </Link>
  );
}
